import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import ActivityLogsComp from './ActivityLogsComp';

function ActivityLogs() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <ActivityLogsComp />
      </div>
    </div>
  );
}

export default ActivityLogs;
